module.exports = __webpack_public_path__ + "static/media/networkingP.9c828e81.jpg";